import CityPageTemplate from "../city-template/CityPageTemplate";
import { gardinerConfig } from "./data";

export default function GardinerPage() {
  return <CityPageTemplate config={gardinerConfig} />;
}